type SharedViewerToolbarProps = {
  fileName: string;
  currentPage: number;
  totalPages: number;
  fullscreenLabel: string;
  onEnterFullscreen: () => void;
  height?: number;
};

export default function SharedViewerToolbar({
  fileName,
  currentPage,
  totalPages,
  fullscreenLabel,
  onEnterFullscreen,
  height = 48,
}: SharedViewerToolbarProps) {
  return (
    <div
      className="flex items-center justify-between px-4 bg-black/70 backdrop-blur-sm flex-shrink-0"
      style={{ height }}
    >
      <span className="text-white/80 text-sm truncate max-w-xs font-medium">
        {fileName}
      </span>
      <div className="flex items-center gap-3">
        <span className="text-white/50 text-xs">
          {currentPage} / {totalPages}
        </span>
        <button
          onClick={onEnterFullscreen}
          className="flex items-center gap-1.5 px-3 py-1.5 hover:bg-white/10 text-white rounded-md text-xs font-medium transition-all cursor-pointer"
        >
          <i className="ri-fullscreen-line"></i>
          {fullscreenLabel}
        </button>
      </div>
    </div>
  );
}
